import React from "react";
import VendorImages from "../../Component/Modal/VendorImages";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import venues_demo_image from "../../Images/venues/venues_demo_image.jpg";

export default function VendorLeft({VenuesDetails, vendorSlug = ""}) {
  return (
    <div className="venues-service-details-page-section-left-side-con position-relative">
      <h1
        style={{
          textTransform: "capitalize",
          fontSize: 16,
          fontWeight: 600,
        }}
      >
        {vendorSlug.split("-").join(" ")}
      </h1>
      <Swiper
        spaceBetween={20}
        pagination={{
          type: "fraction",
        }}
        modules={[Pagination]}
        className="mySwiper"
      >
        <SwiperSlide className="w-100 h-100">
          <div className="venues-service-details-page-image-con">
            <img
              className="w-100 h-100"
              src={VenuesDetails?.cover_image || venues_demo_image}
              alt={VenuesDetails?.name}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = venues_demo_image;
              }}
            />
          </div>
        </SwiperSlide>
        {VenuesDetails?.images?.map((img, idx) => (
          <SwiperSlide key={idx} className="w-100 h-100">
            <div className="venues-service-details-page-image-con">
              <img
                className="w-100 h-100"
                src={img?.image || venues_demo_image}
                alt={VenuesDetails?.name}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = venues_demo_image;
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <VendorImages VenuesDetails={VenuesDetails} />
    </div>
  );
}
